import { Cards, CustomIcon } from 'ams-ui-reactkit';
import { Button, Typography } from "@material-ui/core";
import DynamicHtml from "../../molecules/DynamicHtml"
import { TemplateProps } from '../../journeys/journey/Interfaces';
import './LetsFinalizeStyles.scss'
import { LetsFinalizeImage } from '../../assets/images';
import { navigate } from '@reach/router';
import { useState, useEffect } from 'react';
import { useContextSelector } from '@fluentui/react-context-selector';
import { StoreContext } from '../../context';

const LetsFinalize: React.FC<TemplateProps> = (props: any) => {

    const dispatch: any = useContextSelector(StoreContext, store => store?.dispatch);
    const customerInfoState: any = useContextSelector(StoreContext, store => store?.appState?.customerInfo);
    const { templateProps } = props;

    const { script, data, footer } = templateProps;
    const [loading, setLoading] = useState(false);

    const SingleRowIterator = ({ label, value }: any) => {
        return <div className='singleRowIterator'>
            <Typography variant="subtitle2" component="span" className='singleRowLabel'>
                <DynamicHtml tagName="div" content={label} />
            </Typography>
            <Typography variant="body2" component="span" className='singleRowValue'>
                <DynamicHtml tagName="div" content={value} />
            </Typography>
        </div>
    }

    const handleContinue = () => {
        // console.log(templateProps);
        if (templateProps.options === 4) {
            navigate('newprotection');
        } else {
            navigate(templateProps?.nextScreen || '/')
        }
        //
    }
    console.log("Finalize customerInfoState:", customerInfoState);
    return (
        <div className='finalizeScreen'>
            {/* <Header backNav={false} progressValue={0} /> */}
            <div className="outlineContainer">
                <div className="baseContainerBlock">
                    <div>
                        <Cards variant="primary">
                            <div className="thankyoumainblock">
                                <div className="thankyouimg">
                                    <img src={LetsFinalizeImage} alt="" />
                                </div>
                                <Typography variant="body2" component="span" className="thankyoudesc">
                                    <DynamicHtml tagName="div" content={script} />
                                </Typography>
                            </div>
                        </Cards>
                    </div>
                    <div>
                        <Cards variant="default">
                            <div>
                                {data?.map((item: any, index: any) => {
                                    return <SingleRowIterator key={index} {...item} />
                                })}
                            </div>
                        </Cards>
                    </div>
                    <div>
                        <Typography variant="subtitle2" component="span" className='footerText'>
                            <DynamicHtml tagName="div" content={footer} />
                        </Typography>
                    </div>
                    <div className={`staticFixedButton mt-8 `}>
                        <Button
                            onClick={() => handleContinue()}
                            color="primary"
                            variant="contained"
                            disabled={loading}
                            size="large"
                            className='commonBtnClass'
                        >
                            {templateProps?.button}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LetsFinalize